module.exports = __webpack_public_path__ + "img/healthcare.49b74b23.svg";